<template>
  <svg viewBox="0 0 1199 1722" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M612 949c108 0 216-51 216-173 0-66-38-117-99-139v-2c50-24 76-60 76-109 0-108-103-142-194-142-92 0-197 36-197 144 0 49 25 84 76 108v2c-62 25-99 76-99 143 0 122 116 168 221 168zm-13-825c292 0 528 236 528 528 0 291-236 528-528 528-291 0-528-237-528-528 0-292 237-528 528-528zm12 561c58 0 106 29 106 92 0 59-55 85-107 85-33 0-59-7-78-23-20-15-29-36-29-62 0-63 50-92 108-92zm-1-75c-28 0-50-7-66-21-17-13-25-31-25-52 0-51 46-72 91-72s89 21 89 72c0 50-44 73-89 73z" />
  </svg>
</template>
